/**
 * @generated SignedSource<<f8443402b827b2ca0ee8cc70cf0d83e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_user" | "PdpRespDetails_user">;
  readonly " $fragmentType": "PdpRespAboutModule_user";
};
export type PdpRespAboutModule_user$key = {
  readonly " $data"?: PdpRespAboutModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "74086f266aefc817f25d94a3ea02e3d4";

export default node;
